import {ChangeDetectionStrategy, Component, Inject, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {environment} from "../../../../../environments/environment";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../../config/hotel-tours-list-page.config";

@Component({
    selector: 'app-filter-horizontal',
    templateUrl: environment.mobile ? './filter-horizontal.component.mobile.html' : './filter-horizontal.component.html',
    styleUrls: environment.mobile ? ['./filter-horizontal.component.mobile.scss'] : ['./filter-horizontal.component.scss'],
    imports: [
        CommonModule,
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterHorizontalComponent {
  @Input() isActive = false;
  @Input() viewValue!: string;
  @Input() filterValue!: number;
  @Input() count!: number;
  @Input() filterKey!: string;

  messages: any = {};

  constructor(@Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig) {
    this.messages = {
      'seaLine': this.hotelToursPageConfig.translates.filters.seaLine,
    };
  }
}
